<template>
    <a class="web-components-order_cart-button__button button" :class="getClass" :href="getUrl">
        <span class="icon" v-if="insideCart"><i class="fas fa-arrow-left"></i></span>
        <template v-else>
          <span class="icon"><i class="fas fa-shopping-cart"></i></span>
        </template>
        <span>{{ getLabel }}</span>
        <span class="tag is-white has-text-danger has-text-weight-bold ml-3" v-if="!insideCart && totalAmount > 0">{{ totalAmount }}</span>
    </a>
</template>

<script>
import cartActions from '../../../store/web/cart/action-types';
import cartGetters from '../../../store/web/cart/getter-types';
import cartMutations from '../../../store/web/cart/mutation-types';

export default {
  props: [
      'insideCart',
      'size',
      'onlineOrderingUrl',
      'cartUrl',
  ],
  computed: {
    getUrl() {
      if (this.itemPrice <= 0) {
        return this.onlineOrderingUrl;
      }
      if (this.insideCart) {
        return this.onlineOrderingUrl;
      }
      return this.cartUrl;
    },
    getLabel() {
      if (this.itemPrice <= 0) {
        return this.$t('orders.zeroItems');
      }
      if (this.insideCart) {
        return this.$t('orders.actions.back');
      }
      return 'Zobrazit košík';
    },
    getClass() {
      return {
        'is-small': this.size === 'is-small',
        'is-fullwidth': this.size === 'is-fullwidth',
        'is-danger': this.itemPrice > 0 && !this.insideCart,
        'is-default has-background-white-ter': this.itemPrice <= 0 || this.insideCart,
      };
    },
    itemPrice() {
      return this.$store.getters['cart/' + cartGetters.GET_ITEM_PRICE];
    },
    itemPriceFormatted() {
      return this.$store.getters['cart/' + cartGetters.GET_ITEM_PRICE_FORMATTED];
    },
    totalAmount() {
      return this.$store.getters['cart/' + cartGetters.GET_TOTAL_AMOUNT];
    },
  }
}
</script>

<style>

</style>
